export default __webpack_public_path__ + "static/uchida-06abcf0a7f54c3c4a1fbddc964e5818b.jpg";